import '../../home/EsHomeFeatures.css';

import { esCrafterAsset, esCrafterBool, esCrafterList, esCrafterXb } from '../../../common/EsCrafter';
import { esBoldImpCommand, esFeatureHeading } from '../../home/EsHomeFeatures';

/* EsHomeFeatures' grid, its cards from a feature-cards block: es-<slug>-<key> for the
   section and es-<slug>-feature-<card> per card, EsHomeFeatures' own testids. */
export default function EsBlockFeatureCards( { slug, block, item } ) {
    const aId = `es-${ slug }-${ block.key_s }`;

    return (
        <section id={ block.key_s } data-testid={ aId } className="pt-[50px]" { ...esCrafterXb( item, block ) }>
            <div className="container">
                <div className="border-t border-section-rule pt-[78px]">
                    <div className="flex flex-wrap mx-[-16px]">
                        <div className="w-full px-4">
                            <div className="sectionHeading wow fadeInU" data-wow-delay=".1s">
                                <h2 data-testid={ `${ aId }-title` } className="sectionTitle" { ...esCrafterXb( item, block, 'title_s' ) }>{ block.title_s }</h2>
                                <p data-testid={ `${ aId }-blurb` } className="bodyText" { ...esCrafterXb( item, block, 'blurb_t' ) }>{ block.blurb_t }</p>
                            </div>
                        </div>
                    </div>
                    { /* The same grid EsHomeFeatures draws (Tim, 2026-10-12): the icon on the
                         heading's line, Principles' 80px gutter, 48px between rows. wide_b
                         gives a wide icon one more notch of width at the same height. */ }
                    <div className="mb-10 grid gap-x-20 gap-y-12 md:grid-cols-2 lg:grid-cols-3" data-testid={ `es-${ slug }-feature-grid` }>
                        { esCrafterList( block.cards_o ).map( ( pCard, pIndex ) => {
                            const aCard = `es-${ slug }-feature-${ pCard.key_s }`;
                            const aSize = esCrafterBool( pCard.wide_b ) ? 'h-9 w-10' : 'h-9 w-9';
                            return (
                                <div key={ pCard.key_s } data-testid={ aCard } className="wow fadeInUp" data-wow-delay=".15s"
                                     { ...esCrafterXb( item, block, 'cards_o', pIndex ) }>
                                    <div className="mb-3 flex items-center gap-3">
                                        <img src={ esCrafterAsset( pCard.imageLight_s, item ) } alt={ pCard.alt_s } className={ `${ aSize } dark:hidden` } />
                                        <img src={ esCrafterAsset( pCard.imageDark_s, item ) } alt={ pCard.alt_s } className={ `hidden ${ aSize } dark:block` } />
                                        <h3 data-testid={ `${ aCard }-heading` } className="featureHeading">{ esFeatureHeading( pCard.heading_s ) }</h3>
                                    </div>
                                    <p data-testid={ `${ aCard }-blurb` } className="featureBlurb">{ esBoldImpCommand( pCard.blurb_t ) }</p>
                                </div>
                            );
                        } ) }
                    </div>
                </div>
            </div>
        </section>
    );
}
